import React, {useContext} from "react";
import parse from 'html-react-parser';
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import UpdateAddresses from "./UpdateAddresses";
import {Modal} from "react-bootstrap";

//this component contains the record of origin address ,destination address and extra stops
const EstimateAddressSubComponent = (props) => {
    return(
        <li>
            <div className="estimate-arrival-time">
                <span className="addres-span">{props.Title}</span>
                {parse(`${props.Address}`)}
            </div>
        </li>
    );
}
export default () => {
    let Record = useContext(RecordsManagementContext)
    let records = Record.CP_PageDetails.EstimateAddress
    let isUpdateAddress = Record.CP_PageDetails.editFields.address
    const EditAddresses = () => {
        Record.setAddressesModal(true)
    }
    const handleModal = () => {
        Record.setAddressesModal(false)
    }

    return(
        <>
            <div className="estimate-time-mapping mt-4">
                <ul className="time-mapping-list pl-0 mb-0">
                    <EstimateAddressSubComponent Title="Origin Address" Address={records.OriginAddress}/>
                    <EstimateAddressSubComponent Title="Extra Stop(s)" Address={records.ExtraStops}/>
                    <EstimateAddressSubComponent Title="Destination Address" Address={records.DestinationAddress}/>
                    {Record.IsJobOpen && isUpdateAddress ?
                        <button className='btn btn-dark btn-sm ' onClick={() => EditAddresses()}>
                            <b>Edit</b></button>
                        : <></>
                    }
                </ul>

            </div>
            <Modal show={Record.AddressesModal} onHide={()=>handleModal()} className='update-adder-info-wrap'
            >
                <Modal.Header  className= "update-addr-header"><h5 style={{color: "#37abdb", fontSize: "16px", fontWeight: 500,paddingTop:"2.2%"}}>
                    Update Addresses </h5>
                    <button onClick={handleModal} className="addr-close-btn"
                            style={{color: "red",background: "white",border: "white",paddingTop:"14px",paddingBottom:"1%"}}>
                        <span><div style={{fontSize:"125%", fontWeight: "bold"}}>x</div></span></button></Modal.Header>
                <Modal.Body className="update-addr-modal-body"  > <UpdateAddresses/></Modal.Body>
            </Modal>
        </>
    );
}

